import * as React from "react";
import { Button, Card, CardBody } from "reactstrap";

export type FenceSegmentCardInProgressProps = {
  handleCancelDrawingInProgress: (e: React.MouseEvent<HTMLButtonElement>) => void;
};
export function FenceSegmentCardInProgress(props: FenceSegmentCardInProgressProps) {
  return (
    <Card className="border border-primary border-2 mb-2" style={{ background: "#f0f4f8" }}>
      <CardBody className="py-3 text-center">
        <div className="ds-label mb-2">Drawing in progress…</div>
        <Button color="danger" outline size="sm" onClick={props.handleCancelDrawingInProgress}>
          Cancel
        </Button>
      </CardBody>
    </Card>
  );
}
